export default __webpack_public_path__ + "static/media/icon-5.6ac2c893.png";